import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { Link } from "react-router-dom";
import ListGroup from "../../../../atoms/listGroup";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

const Screen = () => {
  const role = localStorage.getItem("role");
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
      },
    },
  };
  const labels = [
    `Q1 2020`,
    "Q2 2020",
    "Q3 2020",
    "Q1 2021",
    "Q2 2021",
    "Q3 2021",
    "Q1 2022",
    "Q2 2022",
    "Q3 2022",
  ];
  const data = () => {
    return {
      labels,
      datasets: [
        {
          label: "Business 1",
          fill: true,
          data: [10, 18, 25, 45, 50, 75, 95, 100, 150],
          borderColor: "rgba(232, 142, 8, 1)",
          pointRadius: 7,
          borderWidth: 4,
          pointBorderWidth: 0,
          pointBackgroundColor: "rgba(51, 51, 51, 1)",
          backgroundColor: (context) => {
            const ctx = context.chart.ctx;
            const gradient = ctx.createLinearGradient(0, 0, 0, 700);
            gradient.addColorStop(0, "rgba(250,174,50,1)");
            gradient.addColorStop(1, "rgba(250,174,50,0.2)");
            return gradient;
          },
        },
        {
          label: "Business 2",
          fill: true,
          data: [110, 118, 125, 145, 150, 175, 195, 200, 250],
          borderColor: "rgba(11, 89, 14, 1)",
          pointRadius: 7,
          borderWidth: 4,
          pointBorderWidth: 0,
          pointBackgroundColor: "rgba(51, 51, 51, 1)",
          backgroundColor: (context) => {
            const ctx = context.chart.ctx;
            const gradient = ctx.createLinearGradient(0, 0, 0, 700);
            gradient.addColorStop(0, "rgba(11, 89, 14, 1)");
            gradient.addColorStop(1, "rgba(11, 89, 14, 0.2)");
            return gradient;
          },
        },
        {
          label: "Business 3",
          fill: true,
          data: [210, 228, 245, 265, 270, 295, 225, 300, 450],
          borderColor: "rgba(109, 17, 11, 1)",
          pointRadius: 7,
          borderWidth: 4,
          pointBorderWidth: 0,
          pointBackgroundColor: "rgba(51, 51, 51, 1)",
          backgroundColor: (context) => {
            const ctx = context.chart.ctx;
            const gradient = ctx.createLinearGradient(0, 0, 0, 700);
            gradient.addColorStop(0, "rgba(109, 17, 11, 1)");
            gradient.addColorStop(1, "rgba(109, 17, 11, 0.2)");
            return gradient;
          },
        },
        {
          label: "Business 4",
          fill: true,
          data: [310, 328, 445, 465, 570, 495, 325, 400, 650],
          borderColor: "rgba(49, 131, 207, 1)",
          pointRadius: 7,
          borderWidth: 4,
          pointBorderWidth: 0,
          pointBackgroundColor: "rgba(51, 51, 51, 1)",
          backgroundColor: (context) => {
            const ctx = context.chart.ctx;
            const gradient = ctx.createLinearGradient(0, 0, 0, 700);
            gradient.addColorStop(0, "rgba(49, 131, 207, 1)");
            gradient.addColorStop(1, "rgba(49, 131, 207, 0.2)");
            return gradient;
          },
        },
      ],
    };
  };

  return (
    <div className="h-screen m-10">
      <div className="flex">
        <div className="font2 w-[49%] ">
          <h1 className="text-[24px]">Business Valuation</h1>
        </div>
        <div className="w-[50%] flex justify-end">
          {role === "business" && (
            <div className="flex justify-center items-center mr-2">
              <h4 className="mr-2">Add: </h4>
              <Link
                to="/business/dashboard/value-business/create"
                className="border-2 rounded-lg p-2 font2 shadow-[0_15px_12px_-12px_rgba(0,0,0,0.3)]"
              >
                Value Business +
              </Link>
            </div>
          )}
          <div className=" flex justify-center items-center mr-2">
            <h4 className="font2 mr-2">Filter</h4>
            <div className="w-[8rem]">
              <ListGroup
                option={[
                  { value: "Quartal 1", label: "Quartal 1" },
                  { value: "Quartal 2", label: "Quartal 2" },
                  { value: "Quartal 3", label: "Quartal 3" },
                  { value: "Quartal 4", label: "Quartal 4" },
                ]}
              />
            </div>
          </div>
          <div className="flex justify-center items-center w-[8rem]">
            <ListGroup
              option={[
                { value: "Quartal 1", label: "Quartal 1" },
                { value: "Quartal 2", label: "Quartal 2" },
                { value: "Quartal 3", label: "Quartal 3" },
                { value: "Quartal 4", label: "Quartal 4" },
              ]}
            />
          </div>
        </div>
      </div>

      <Line options={options} data={data()} />
    </div>
  );
};

export default Screen;
